export default function joinList(items: string[] | undefined | null, lastSeparator: string) {
  if (!items) return '';
  if (items.length === 0) return '';
  if (items.length === 1) {
    return items[0];
  }
  return `${items.slice(0, -1).join(', ')} ${lastSeparator} ${items[items.length - 1]}`;
}
